export default __webpack_public_path__ + "static/media/DuitNowQR_Primary.478b7a7a.png";